// extracted by mini-css-extract-plugin
module.exports = {"container":"Tile_container__2Xpoz","pictos":"Tile_pictos__ftKym","picto":"Tile_picto__1yW9_","title":"Tile_title__3eeyL","description":"Tile_description__2hbho"};